import Reveal from "@/components/feature/Reveal";

const values = [
  {
    title: "Hospitality",
    text: "Creating genuine, welcoming experiences for every guest.",
  },
  {
    title: "Quality",
    text: "Maintaining high standards across every aspect of the operation.",
  },
  {
    title: "Consistency",
    text: "Delivering reliable experiences through thoughtful systems and attention to detail.",
  },
  {
    title: "Integrity",
    text: "Building lasting relationships through professionalism and accountability.",
  },
];

export default function Values() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-10">
        <Reveal className="text-center max-w-2xl mx-auto">
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-primary-600 font-medium">
            Our Foundation
          </p>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight tracking-tight">
            What We Value
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {values.map((value, i) => (
            <Reveal key={value.title} delay={i * 100}>
              <div className="h-full border-t-2 border-accent-400 pt-6">
                <div className="flex items-center gap-3">
                  <span className="w-8 h-8 flex items-center justify-center">
                    <i className="ri-checkbox-circle-line text-primary-600 text-xl"></i>
                  </span>
                  <h3 className="font-heading text-xl md:text-2xl text-foreground-950">
                    {value.title}
                  </h3>
                </div>
                <p className="mt-4 text-foreground-600 leading-relaxed font-light text-sm md:text-base">
                  {value.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}